module.exports = __webpack_public_path__ + "static/media/onecask-min.eb982040.png";